import axios from "axios";
import {Dialog, Toast} from "vant";
// import {UtilMainJS} from "./utilMain";
import qs from 'qs'

axios.defaults.timeout = 50000; //请求超时时间
//axios.defaults.withCredentials=true;

// 请求拦截----------------------------------------------------------------
axios.interceptors.request.use(
    (config) => {
        const user = "";
        if (user) {
            config.headers = {
                Authorization: "bearer " + user.token,
            };
        }
        config.headers = {
            'Content-Type': 'application/x-www-form-urlencoded; charset=utf-8;'
        }
        return config;
    },
    (error) => {
        return Promise.reject(error);
    },
    (error) => {
        return Promise.reject(error);
    }
);

// 响应拦截----------------------------------------------------------------
axios.interceptors.response.use(
    function (res) {
        let status = res.data.status,
            message = res.data.msg;
        switch (status) {
            case 1:
                return res;
                break;
            default: //默认异常提示
                Dialog.alert({
                    title: "提示",
                    message: message ? message : "网络请求异常，请稍候再试"
                }).then(r => function () {

                });
                break;
        }

    },
    (error) => {
        // UtilMainJS.BRDialog("3213123","312312321");
        Dialog.alert({
            title: '提示',
            message: error.message.includes('timeout') ? '网络请求超时，请稍候再试' : '网络请求异常，请稍候再试'
        }).then(r => function () {

        });
        return Promise.reject(error);
    }
);

/**
 * 封装请求
 * @param url
 * @param params
 * @param method
 * @param loading
 * @returns {Promise}
 */
export function apiAxios(url, params = {}, method = "post", loading = true) {
    if (loading) {
        Toast.loading({
            message: "加载中...",
            duration: 1000000,
        });
    }
    method = method.toUpperCase(); //转成大写
    let config = {
        method: method,
        url: url,
        transformRequest: [
            function (data) {
                return qs.stringify(params);
            }
        ]
    };

    return new Promise((resolve, reject) => {
        axios(config)
            .then((res) => {
                if (loading) {
                    Toast.clear();
                }
                if (res.status === 200) {
                    resolve(res.data);
                }
            })
            .catch((response) => {
                if (loading) {
                    Toast.clear();
                }
                reject(response);
            });
    });
}



// WEBPACK FOOTER //
// ./src/utils/http.js